import {Component, store} from '../../index';

export default class PackageBoxes extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('.cart-boxes-wrapper'),
      state: store.state,
    });
  }

  render() {
    document.querySelectorAll('.cart-box').forEach((cartBox, index) => {
      let classList = cartBox.classList;
      if (this.state.selected_package_index == index) {
        classList.add('active');
      } else {
        classList.remove('active');
      }
    });
  }
}
